/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  getSummary(conversationID) {
    return axios.get(`${this.url}/${conversationID}/summary`);
  }

  createSummary(conversationID, summary, metadata = {}) {
    return axios.post(`${this.url}/${conversationID}/summary`, {
      conversation_summary: {
        summary,
        metadata,
      },
    });
  }

  updateSummary(conversationID, summary, metadata = {}) {
    return axios.patch(`${this.url}/${conversationID}/summary`, {
      conversation_summary: {
        summary,
        metadata,
      },
    });
  }

  export({ fromDate, toDate } = {}) {
    return axios.get(`${this.url}/export`, {
      params: {
        from_date: fromDate,
        to_date: toDate,
      },
      responseType: 'text',
    });
  }
}

export default new ConversationApi();
